export const ASSETS = {
  logoLarge: "/app/waidbook-mark-560.webp",
  logoSmall: "/app/waidbook-mark-160.webp",
  heroBg:
    "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?crop=entropy&cs=srgb&fm=jpg&w=1800&q=70",
  screenLogin: "/app/screen-login-nl.jpg",
};

// Verified live Waidbook web app (production, not preview)
export const WEB_APP_URL = "https://hunt-tracker-13.emergent.host/login";

export const SUPPORT_EMAIL = "support@waidbook.nl";
